
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("2J0VA", function(module, exports) {

$parcel$export(module.exports, "NonCriticalDesShareLinkFlag", () => $c73d3b51716f8ab8$export$a2f082d63aa2b034);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $k8Qyf = parcelRequire("k8Qyf");

var $6U1dF = parcelRequire("6U1dF");

var $apQzE = parcelRequire("apQzE");

var $jD3pk = parcelRequire("jD3pk");

var $9LnOZ = parcelRequire("9LnOZ");

var $fzAr1 = parcelRequire("fzAr1");

var $ledru = parcelRequire("ledru");
const $c73d3b51716f8ab8$export$dfc6e3d89170b477 = ()=>{
    const { showShareLinkThroughDesFlag: showShareLinkThroughDesFlag } = (0, $9LnOZ.useShareDesLinkFlag)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const isEligible = (0, $ledru.useIsEligibleForDesShareLinkExperiment)();
    const [hasInteractedWithDesShareLinkFlag] = (0, $apQzE.useHasSeenIt)({
        hasSeenItKey: 'desShareLinkFlag',
        skipFetch: !isEligible
    });
    const { hasFlag: hasFlag } = (0, $k8Qyf.useFlagsService)();
    (0, $eUqFw.useEffect)(()=>{
        let ignoreResult = false;
        const checkEligibilityAndShowFlagIfInVariation = async ()=>{
            if (hasFlag && hasFlag((0, $9LnOZ.DES_SHARE_LINK_FLAG_ID))) return;
            if (isEligible && hasInteractedWithDesShareLinkFlag?.fetchStatus === 'fetched' && hasInteractedWithDesShareLinkFlag.value === false) {
                const { isDesEnabled: isDesEnabled, domain: domain } = await (0, $fzAr1.checkIsDesEnabled)(orgId);
                if (!ignoreResult && isDesEnabled && domain) {
                    if ((0, $79xbN.expValEquals)('jira_des_link_share', 'isEnabled', true)) showShareLinkThroughDesFlag(domain);
                }
            }
        };
        checkEligibilityAndShowFlagIfInVariation();
        return ()=>{
            ignoreResult = true;
        };
    }, [
        orgId,
        showShareLinkThroughDesFlag,
        hasInteractedWithDesShareLinkFlag,
        isEligible,
        hasFlag
    ]);
    return null;
};
const $c73d3b51716f8ab8$export$a2f082d63aa2b034 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6U1dF.default), {
        teamName: "Jlove-Makkuro",
        id: "non-critical-jira-des-share-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c73d3b51716f8ab8$export$dfc6e3d89170b477, null));

});
parcelRegister("6U1dF", function(module, exports) {

$parcel$export(module.exports, "NonCritical", () => $7c939f739e44c405$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $7c939f739e44c405$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $h3mHU = parcelRequire("h3mHU");
const $7c939f739e44c405$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    }
    return null;
};
const $7c939f739e44c405$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $7c939f739e44c405$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    }
    return null;
};
const $7c939f739e44c405$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$var$NonCriticalComponent, props));
var $7c939f739e44c405$export$2e2bcd8739ae039 = $7c939f739e44c405$var$NonCriticalComponent;

});

parcelRegister("apQzE", function(module, exports) {

$parcel$export(module.exports, "useHasSeenIt", () => $291883f9bc7030d8$export$e45ad3bcdc52605d);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $emnjr = parcelRequire("emnjr");
// Store inits empty - small optimization in case consumers aren't fetching/needing any keys due to
// what's rendered on the page or code FF'd off etc., keys will be added after first get / set
const $291883f9bc7030d8$var$initialState = {};
// Temporary store we can use for onboarding experiments since have-i-seen-it services is recommended NOT to be used
// Later hopefully we can use Post office/the choreographer/choreographed components instead which should add "seen-it"
// functionality (will be later down the track - they are focusing on solving message collisions first)
const $291883f9bc7030d8$var$store = (0, $WBLbN.createStore)({
    name: 'jira-onboarding-has-seen-it',
    initialState: $291883f9bc7030d8$var$initialState,
    actions: $emnjr.actions
});
const $291883f9bc7030d8$export$ef53ed8cd1582794 = (0, $WBLbN.createHook)($291883f9bc7030d8$var$store, {
    selector: (state, hasSeenItKey)=>{
        return state[hasSeenItKey];
    }
});
const $291883f9bc7030d8$export$e45ad3bcdc52605d = ({ hasSeenItKey: hasSeenItKey, skipFetch: skipFetch = false })=>{
    const useLastFetchedHasSeenItResult = $291883f9bc7030d8$export$ef53ed8cd1582794(hasSeenItKey);
    const [, { fetchHasSeen: fetchHasSeen }] = useLastFetchedHasSeenItResult;
    (0, $eUqFw.useEffect)(()=>{
        if (skipFetch) return;
        fetchHasSeen(hasSeenItKey);
    }, [
        fetchHasSeen,
        hasSeenItKey,
        skipFetch
    ]);
    return useLastFetchedHasSeenItResult;
};

});
parcelRegister("emnjr", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ce7c975029fd007a$export$e324594224ef24da);

var $giA54 = parcelRequire("giA54");

var $eIByA = parcelRequire("eIByA");
const $ce7c975029fd007a$export$e324594224ef24da = {
    fetchHasSeen: $giA54.fetchHasSeen,
    setHasSeen: $eIByA.setHasSeen
};

});
parcelRegister("giA54", function(module, exports) {

$parcel$export(module.exports, "fetchHasSeen", () => $498ef2f96774f071$export$e26ab58aa13c0861);

var $e4Oua = parcelRequire("e4Oua");
const $498ef2f96774f071$export$e26ab58aa13c0861 = (hasSeenKey)=>async ({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const currentStateForHasSeenKey = currentState[hasSeenKey];
        if (currentStateForHasSeenKey?.fetchStatus === 'fetched' || currentStateForHasSeenKey?.fetchStatus === 'fetching' || // currently no retry on error
        currentStateForHasSeenKey?.fetchStatus === 'errored') return;
        setState({
            [hasSeenKey]: {
                fetchStatus: 'fetching'
            }
        });
        const response = await (0, $e4Oua.performFetchHasSeenRequest)(hasSeenKey);
        if (response === 'errored') setState({
            [hasSeenKey]: {
                fetchStatus: 'errored'
            }
        });
        else setState({
            [hasSeenKey]: {
                fetchStatus: 'fetched',
                value: response
            }
        });
    };

});
parcelRegister("e4Oua", function(module, exports) {

$parcel$export(module.exports, "performFetchHasSeenRequest", () => $9cd8c205ece66d3d$export$a32677d9d29a038c);

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

var $hpyFn = parcelRequire("hpyFn");
const $9cd8c205ece66d3d$export$a32677d9d29a038c = async (hasSeenKey)=>{
    try {
        const response = await (0, $cm5m0.userPreferenceAPI).get((0, $hpyFn.createHasSeenPrefixedKey)(hasSeenKey));
        // if response is null, it means the user has not interacted with the feature yet
        if (response === null) return false;
        return response;
    } catch (error) {
        if (error instanceof Error) (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'performFetchHasSeenRequest',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true,
            attributes: {
                hasSeenKey: hasSeenKey
            }
        });
        return 'errored';
    }
};

});
parcelRegister("hpyFn", function(module, exports) {

$parcel$export(module.exports, "createHasSeenPrefixedKey", () => $f77ee1f66a799bd9$export$9d92579e0f0fa92e);
const $f77ee1f66a799bd9$export$9d92579e0f0fa92e = (key)=>{
    return `hasSeen-${key}`;
};

});



parcelRegister("eIByA", function(module, exports) {

$parcel$export(module.exports, "setHasSeen", () => $3a5c08b465b2a303$export$17c72042607ae07a);

var $2MgS9 = parcelRequire("2MgS9");
const $3a5c08b465b2a303$export$17c72042607ae07a = (hasSeenKey)=>async ({ setState: setState })=>{
        setState({
            [hasSeenKey]: {
                fetchStatus: 'fetched',
                value: true
            }
        });
        await (0, $2MgS9.performSetHasSeenRequest)(hasSeenKey);
    };

});
parcelRegister("2MgS9", function(module, exports) {

$parcel$export(module.exports, "performSetHasSeenRequest", () => $e91326865af47de3$export$47d7ab51cd61b6bf);

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

var $hpyFn = parcelRequire("hpyFn");
const $e91326865af47de3$export$47d7ab51cd61b6bf = async (hasSeenKey)=>{
    try {
        await (0, $cm5m0.userPreferenceAPI).set((0, $hpyFn.createHasSeenPrefixedKey)(hasSeenKey), true);
    } catch (error) {
        if (error instanceof Error) (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'performSetHasSeenRequest',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true,
            attributes: {
                hasSeenKey: hasSeenKey
            }
        });
    }
};

});




parcelRegister("9LnOZ", function(module, exports) {

$parcel$export(module.exports, "DES_SHARE_LINK_FLAG_ID", () => $fdb23dd63c068ee1$export$8f90048845f70224);
$parcel$export(module.exports, "useShareDesLinkFlag", () => $fdb23dd63c068ee1$export$e8539d574b3fd8c8);

var $eUqFw = parcelRequire("eUqFw");

var $jkH4Q = parcelRequire("jkH4Q");

var $2bv8J = parcelRequire("2bv8J");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $apQzE = parcelRequire("apQzE");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $70uhY = parcelRequire("70uhY");
const $fdb23dd63c068ee1$export$8f90048845f70224 = 'des-share-link-flag';
const $fdb23dd63c068ee1$export$e8539d574b3fd8c8 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isLinkCopied, setIsLinkCopied] = (0, $eUqFw.useState)(false);
    const [, { setHasSeen: setHasSeen }] = (0, $apQzE.useHasSeenIt)({
        hasSeenItKey: 'desShareLinkFlag',
        skipFetch: true
    });
    const copyToClipboard = (0, $eUqFw.useCallback)((url, originAnalyticsAttributes)=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(url).then(()=>{
            setIsLinkCopied(true);
            showFlag({
                type: 'success',
                title: formatMessage((0, $70uhY.messages).copyToClipboardSuccess),
                testId: 'des-share-link.copy-success-flag',
                isAutoDismiss: true
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'shareDesCopyLink succcesful', {
                atlOrigin: originAnalyticsAttributes
            });
        }).catch(()=>{
            showFlag({
                type: 'error',
                title: formatMessage((0, $70uhY.messages).copyToClipboardError),
                testId: 'des-share-link.copy-error-flag',
                isAutoDismiss: true
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'shareDesCopyLink failed', {
                atlOrigin: originAnalyticsAttributes
            });
        }).finally(()=>{
            dismissFlag($fdb23dd63c068ee1$export$8f90048845f70224);
        });
    }, [
        showFlag,
        dismissFlag,
        formatMessage,
        createAnalyticsEvent
    ]);
    const showShareLinkThroughDesFlag = (0, $eUqFw.useCallback)(async (domain)=>{
        showFlag({
            id: $fdb23dd63c068ee1$export$8f90048845f70224,
            type: 'info',
            testId: 'des-share-link.action-success-flag',
            title: formatMessage((0, $70uhY.messages).bannerTitle),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
                label: "Info Icon",
                size: "small"
            }),
            description: formatMessage((0, $70uhY.messages).bannerText, {
                domain: domain
            }),
            isAutoDismiss: false,
            actions: [
                {
                    content: (0, $70uhY.messages).actionText,
                    onClick: ()=>{
                        const origin = new (0, $jkH4Q.default)({
                            product: 'jira'
                        });
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        const originUrl = origin.addToUrl(window.location.href);
                        copyToClipboard(originUrl, origin.toAnalyticsAttributes());
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'shareDesCopyLink clicked');
                        setHasSeen('desShareLinkFlag');
                    }
                }
            ],
            onDismissed: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'shareDesLinkFlagDismiss clicked', {
                    isLinkCopied: isLinkCopied
                });
                setHasSeen('desShareLinkFlag');
            }
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'shareDesLinkFlag viewed');
    }, [
        showFlag,
        formatMessage,
        createAnalyticsEvent,
        copyToClipboard,
        isLinkCopied,
        setHasSeen
    ]);
    return {
        showShareLinkThroughDesFlag: showShareLinkThroughDesFlag
    };
};

});
parcelRegister("2bv8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1974c390fcca76c2$var$_react = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $1974c390fcca76c2$var$_information = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $1974c390fcca76c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1974c390fcca76c2$var$InfoIcon = (props)=>/*#__PURE__*/ $1974c390fcca76c2$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $1974c390fcca76c2$var$_information.default
    }));
$1974c390fcca76c2$var$InfoIcon.displayName = 'InfoIcon';
var $1974c390fcca76c2$var$_default = module.exports.default = $1974c390fcca76c2$var$InfoIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});


parcelRegister("70uhY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2dd4101abd75c7e4$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2dd4101abd75c7e4$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    dismissButtonLabel: {
        "id": "des-share-link.hooks.dismiss-button-label",
        "defaultMessage": "Dismiss"
    },
    bannerTitle: {
        "id": "des-share-link.hooks.banner-title",
        "defaultMessage": "Start collaborating with your team"
    },
    bannerText: {
        "id": "des-share-link.hooks.banner-text",
        "defaultMessage": "People with {domain} email addresses have access to this project, so simply send them a link to join."
    },
    actionText: {
        "id": "des-share-link.hooks.action-text",
        "defaultMessage": "Copy link"
    },
    copyToClipboardSuccess: {
        "id": "des-share-link.hooks.copy-to-clipboard-success",
        "defaultMessage": "Link copied, ready to share!"
    },
    copyToClipboardError: {
        "id": "des-share-link.hooks.copy-to-clipboard-error",
        "defaultMessage": "Failed to copy to clipboard"
    }
});

});


parcelRegister("fzAr1", function(module, exports) {

$parcel$export(module.exports, "checkIsDesEnabled", () => $e3d6d728da4c54d2$export$b21647b03228d956);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $3xSja = parcelRequire("3xSja");
const $e3d6d728da4c54d2$var$ELIGIBILITY_CHECK_URL = '/gateway/api/invitations/v1/access-settings/org';
const $e3d6d728da4c54d2$var$noValidDesResult = {
    isDesEnabled: false,
    domain: ''
};
const $e3d6d728da4c54d2$export$b21647b03228d956 = async (orgId)=>{
    if (!orgId) // early exit if we don't have orgId
    return $e3d6d728da4c54d2$var$noValidDesResult;
    const domain = await (0, $3xSja.getDomainWithSource)('shareDesLink');
    if (!domain) // early exit if we don't have domain
    return $e3d6d728da4c54d2$var$noValidDesResult;
    try {
        const response = await (0, $lRmyA.performGetRequestWithRetry)(`${$e3d6d728da4c54d2$var$ELIGIBILITY_CHECK_URL}/${orgId}/domains/${domain}`);
        // 'jira-software' includes JSW and JWM
        const jiraProduct = response.products.find((product)=>product.productARI.includes('jira-software'));
        const isDesEnabled = jiraProduct ? !jiraProduct.adminApprovalRequired : false;
        return {
            isDesEnabled: isDesEnabled,
            domain: domain
        };
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'checkDesSettings',
                packageName: 'jiraDesShareLink',
                teamName: 'jlove-makkuro'
            },
            error: error instanceof Error ? error : new Error('DES check (/gateway/api/invitations/v1/access-settings/org/ORGID/domains/DOMAIN.COM) failed')
        });
        return {
            isDesEnabled: false,
            domain: domain
        };
    }
};

});
parcelRegister("3xSja", function(module, exports) {

$parcel$export(module.exports, "getDomain", () => $eebd15c359f069fa$export$3e8733322718eb9);
$parcel$export(module.exports, "getDomainWithSource", () => $eebd15c359f069fa$export$1c2d3d4fb460ce84);
$parcel$export(module.exports, "getIsEligibleForDES", () => $eebd15c359f069fa$export$3d6e43cbeee37361);
$parcel$export(module.exports, "enableDES", () => $eebd15c359f069fa$export$d3d3f95ad35c6d2c);

var $7RALw = parcelRequire("7RALw");

var $fjnY9 = parcelRequire("fjnY9");

var $3hApV = parcelRequire("3hApV");

var $12Lyg = parcelRequire("12Lyg");
const $eebd15c359f069fa$export$3e8733322718eb9 = async ()=>{
    try {
        const account = await (0, $7RALw.getAtlassianAccountWithRethrow)({
            source: 'autoEnableDES'
        });
        return account?.email.split('@')[1];
    } catch (err) {
        // No need to fire error analytic here as it is fired already in
        // getAtlassianAccountWithRethrow - we can just check the source.
        return undefined;
    }
};
const $eebd15c359f069fa$export$1c2d3d4fb460ce84 = async (source)=>{
    try {
        const account = await (0, $7RALw.getAtlassianAccountWithRethrow)({
            source: source
        });
        return account?.email?.split('@')[1];
    } catch (err) {
        return undefined;
    }
};
const $eebd15c359f069fa$var$getDirectAccessSetting = async (domain, cloudId)=>{
    const request = {
        domain: domain,
        productAri: (0, $12Lyg.makeAri)('jira-software', cloudId),
        setting: 'DIRECT_ACCESS'
    };
    try {
        return await (0, $3hApV.defaultInviteApiClient).getDirectAccessSetting(request);
    } catch (err) {
        (0, $fjnY9.fireErrorAnalytics)({
            attributes: {
                subject: 'getDirectAccessSetting'
            },
            error: err instanceof Error ? err : undefined,
            skipSentry: true
        });
        throw err;
    }
};
const $eebd15c359f069fa$export$3d6e43cbeee37361 = async (domain, cloudId)=>{
    try {
        const { response: directAccessResponse } = await $eebd15c359f069fa$var$getDirectAccessSetting(domain, cloudId);
        if ('desPromotionEligible' in directAccessResponse && directAccessResponse?.desPromotionEligible) return directAccessResponse.desPromotionEligible;
        return false;
    } catch (err) {
        return false;
    }
};
const $eebd15c359f069fa$export$d3d3f95ad35c6d2c = async (domain, cloudId)=>{
    const location = 'jira.onboarding';
    const product = 'jira-software';
    try {
        await (0, $3hApV.defaultInviteApiClient).updateDirectAccessSettings({
            cloudId: cloudId,
            product: product,
            domains: [
                domain
            ],
            location: location
        });
    } catch (err) {
        (0, $fjnY9.fireErrorAnalytics)({
            attributes: {
                subject: 'enableDES'
            },
            error: err instanceof Error ? err : undefined,
            skipSentry: true
        });
    }
};

});
parcelRegister("7RALw", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountWithRethrow", () => $fb5817803e08281a$export$1f20b0741dc598bc);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

const $fb5817803e08281a$export$1f20b0741dc598bc = async ({ source: source } = {})=>{
    try {
        const { extended_profile: { job_title: jobTitle, team_type: teamType }, email: email, account_id: accountId } = await (0, $lRmyA.performGetRequestWithRetry)((0, $f4af0f0c163da88b$export$80945eb3738bcee8));
        return {
            extendedProfile: {
                jobTitle: jobTitle,
                teamType: teamType
            },
            email: email,
            accountId: accountId
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'getAtlassianAccountWithRethrow',
                packageName: 'jiraAtlassianAccount',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                source: source
            },
            error: error
        });
        throw error;
    }
};

});
const $f4af0f0c163da88b$export$80945eb3738bcee8 = '/gateway/api/me';


parcelRegister("fjnY9", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $5db81231fc4e31d6$export$a27c21aa3ed8f0f1);

var $guiFP = parcelRequire("guiFP");

const $5db81231fc4e31d6$export$a27c21aa3ed8f0f1 = ({ attributes: attributes, error: error, skipSentry: // will want to skip sentry in cases where have no control over the errors
// so don't want to get alerted based on sentry error thresholds
skipSentry = false })=>{
    (0, $guiFP.default)({
        meta: {
            id: 'autoEnableDES',
            packageName: (0, $bb0b5691fc911885$export$b8b9d90f9e5bd72b),
            teamName: (0, $bb0b5691fc911885$export$2b3151a089bc8780)
        },
        attributes: attributes,
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        skipSentry: skipSentry
    });
};

});
const $bb0b5691fc911885$export$b8b9d90f9e5bd72b = 'jiraSoftwareAutoEnableDes';
const $bb0b5691fc911885$export$2b3151a089bc8780 = 'jlove-makkuro';


parcelRegister("3hApV", function(module, exports) {

$parcel$export(module.exports, "defaultInviteApiClient", () => $3c77b9e0a361727d$export$c993591f6996ca09);

var $6zniz = parcelRequire("6zniz");
const $3c77b9e0a361727d$export$c993591f6996ca09 = new (0, $6zniz.InviteApiClientImpl)();

});
parcelRegister("6zniz", function(module, exports) {

$parcel$export(module.exports, "InviteApiClientImpl", () => $68373ccb197c96b4$export$72a09965ba18562f);


var $ai5Zi = parcelRequire("ai5Zi");

var $12Lyg = parcelRequire("12Lyg");
class $68373ccb197c96b4$export$72a09965ba18562f {
    constructor(){
        this.clearDESCache = ()=>{
            this.directAccessSettingsCache.clear();
        };
        this.directAccessSettingsCache = new Map();
    }
    async updateDirectAccessSettings({ product: product, cloudId: cloudId, location: location, domains: domains }) {
        const resource = `ari:cloud:${product}::site/${cloudId}`;
        const url = `${(0, $9c129065cd58371e$export$ab2f49a861856bab)}${(0, $9c129065cd58371e$export$e84ade9978c1dd85)}`;
        const request = {
            resource: resource,
            domains: domains,
            location: location,
            action: 'ACCEPT',
            setting: 'DIRECT_ACCESS'
        };
        await (0, $ai5Zi.postRequest)(url, 'updateDirectAccessSettings', request);
        return {
            success: true,
            updateDirectAccessSettings: true
        };
    }
    async getDirectAccessSetting(request) {
        const performFetch = ()=>{
            const url = `${(0, $9c129065cd58371e$export$ab2f49a861856bab)}${(0, $9c129065cd58371e$export$e84ade9978c1dd85)}`;
            const queryParams = `resource=${request.productAri}&domain=${request.domain}&setting=${request.setting}${request.roleAri ? `&role=${request.roleAri}` : ''}`;
            return (0, $ai5Zi.fetchJson)(`${url}?${queryParams}`, 'getDirectAccessSetting');
        };
        const cacheValue = this.directAccessSettingsCache.get(request.domain);
        if (cacheValue) return {
            response: cacheValue,
            cached: true
        };
        try {
            const responseJson = await performFetch();
            (0, $12Lyg.tryCacheWithClear)(this.directAccessSettingsCache, request.domain, responseJson);
            return {
                response: responseJson,
                cached: false
            };
        } catch (err) {
            const { responseCode: responseCode, errorMessage: errorMessage } = (0, $12Lyg.resolveError)(err);
            if (responseCode && responseCode >= (0, $ai5Zi.RespCodes).BAD_REQUESTS && responseCode <= (0, $ai5Zi.RespCodes).CLIENT_CLOSED_REQUEST) {
                const failResponseJson = {
                    domain: request.domain,
                    errorMessage: errorMessage
                };
                (0, $12Lyg.tryCacheWithClear)(this.directAccessSettingsCache, request.domain, failResponseJson);
            }
            throw err;
        }
    }
}

});
// URLs
const $9c129065cd58371e$export$ab2f49a861856bab = '/gateway/api';
const $9c129065cd58371e$export$e84ade9978c1dd85 = '/invitations/v1/settings/domain-enabled-signup-promotion';
const $9c129065cd58371e$export$66fa0c6c43bacd3 = '/permissions/permitted';

parcelRegister("ai5Zi", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $a0c7a6214d60a0cd$export$26e841bcf1aeb894);
$parcel$export(module.exports, "RespCodes", () => $a0c7a6214d60a0cd$export$162547ab8fc29e40);
$parcel$export(module.exports, "postRequest", () => $a0c7a6214d60a0cd$export$42ff643f16b1faa2);
$parcel$export(module.exports, "fetchJson", () => $a0c7a6214d60a0cd$export$6d71b655afe1638d);
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */ /* eslint-disable @typescript-eslint/no-explicit-any */ class $a0c7a6214d60a0cd$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) super(responseJson.message);
        else super(`Received error response during action ${action}: ${response.statusText}`);
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
var $a0c7a6214d60a0cd$export$162547ab8fc29e40;
(function(RespCodes) {
    RespCodes[RespCodes["NO_CONTENT"] = 204] = "NO_CONTENT";
    RespCodes[RespCodes["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    RespCodes[RespCodes["BAD_REQUESTS"] = 400] = "BAD_REQUESTS";
    RespCodes[RespCodes["CLIENT_CLOSED_REQUEST"] = 499] = "CLIENT_CLOSED_REQUEST";
})($a0c7a6214d60a0cd$export$162547ab8fc29e40 || ($a0c7a6214d60a0cd$export$162547ab8fc29e40 = {}));
const $a0c7a6214d60a0cd$var$handleFailedResponse = async (response, action)=>{
    let failedResponseJson;
    try {
        failedResponseJson = await response.json();
    } catch  {
    /* empty */ }
    throw new $a0c7a6214d60a0cd$export$26e841bcf1aeb894(action, response.status, response, failedResponseJson);
};
const $a0c7a6214d60a0cd$var$handleErrorResponse = (err, message)=>{
    if (err instanceof $a0c7a6214d60a0cd$export$26e841bcf1aeb894) throw err;
    else if (err instanceof Error) // eslint-disable-next-line prefer-template, no-param-reassign
    err.message = message + `: ${err.message}`;
    throw err;
};
const $a0c7a6214d60a0cd$export$42ff643f16b1faa2 = async (url, action, data)=>{
    try {
        const response = await fetch(url, {
            credentials: 'include',
            method: 'POST',
            ...$a0c7a6214d60a0cd$var$requestTemplate(data)
        });
        if (response.ok) return response;
        return $a0c7a6214d60a0cd$var$handleFailedResponse(response, action);
    } catch (err) {
        const message = `Error while executing post request for ${action}`;
        return $a0c7a6214d60a0cd$var$handleErrorResponse(err, message);
    }
};
const $a0c7a6214d60a0cd$export$6d71b655afe1638d = async (url, action, init)=>{
    try {
        const response = await fetch(url, {
            credentials: 'include',
            ...init
        });
        if (response.status === 304) return response.json();
        if (response.ok) return response.status === 204 ? undefined : response.json();
        return $a0c7a6214d60a0cd$var$handleFailedResponse(response, action);
    } catch (err) {
        const message = `Error while executing fetch for ${action}`;
        return $a0c7a6214d60a0cd$var$handleErrorResponse(err, message);
    }
};
const $a0c7a6214d60a0cd$var$requestTemplate = (data, recaptchaToken)=>({
        headers: {
            'Content-Type': 'application/json',
            ...recaptchaToken ? {
                'G-Recaptcha-Token': recaptchaToken
            } : {}
        },
        body: JSON.stringify(data)
    });
const $a0c7a6214d60a0cd$export$c776284ef4b1209a = (url, action, data, recaptchaToken)=>$a0c7a6214d60a0cd$export$6d71b655afe1638d(url, action, {
        method: 'POST',
        ...$a0c7a6214d60a0cd$var$requestTemplate(data, recaptchaToken)
    });

});

parcelRegister("12Lyg", function(module, exports) {

$parcel$export(module.exports, "makeAri", () => $467f7a78be502e83$export$ab73fcfda18c2aeb);
$parcel$export(module.exports, "tryCacheWithClear", () => $467f7a78be502e83$export$a117c7b833c15650);
$parcel$export(module.exports, "resolveError", () => $467f7a78be502e83$export$b164e8e46eadcf65);
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */ 
var $byYfF = parcelRequire("byYfF");

var $3XyGA = parcelRequire("3XyGA");

var $ai5Zi = parcelRequire("ai5Zi");
const $467f7a78be502e83$export$ab73fcfda18c2aeb = (productId, cloudId)=>`ari:cloud:${productId}::site/${cloudId}`;
const $467f7a78be502e83$export$a117c7b833c15650 = (cache, key, value, size = 50)=>{
    if (cache.size >= size) cache.clear();
    cache.set(key, value);
};
const $467f7a78be502e83$export$b164e8e46eadcf65 = (errorResponse)=>{
    if (errorResponse instanceof (0, $ai5Zi.FetchError)) return {
        error: errorResponse,
        errorMessage: errorResponse.message,
        responseCode: errorResponse.responseCode
    };
    if (errorResponse instanceof (0, $3XyGA.FetchError)) return {
        error: errorResponse,
        errorMessage: errorResponse.message,
        responseCode: errorResponse.statusCode
    };
    if (errorResponse instanceof Error) return {
        error: errorResponse,
        errorMessage: errorResponse.message
    };
    const error = (0, $byYfF.default)(errorResponse);
    return {
        error: error,
        errorMessage: error.message
    };
};

});





parcelRegister("ledru", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForDesShareLinkExperiment", () => $a535dee5e72444bb$export$5d4001dfef33123d);

var $exb0h = parcelRequire("exb0h");

var $hCxgq = parcelRequire("hCxgq");

var $cLjmt = parcelRequire("cLjmt");

var $10fdS = parcelRequire("10fdS");

var $1R3n5 = parcelRequire("1R3n5");
// Search under `src/packages/router-routes` for the routes
const $a535dee5e72444bb$var$eligibleRoutes = [
    // Board View
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
    // Timeline View
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
    // List View
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
    // Backlog View
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
    // note: looks like JWM doesn't have a backlog view
    // Calendar View
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
    // Issues View
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
    // Issue View
    (0, $exb0h.ROUTE_NAMES_ISSUE),
    // Summary, Approvals, Form, Pages
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
    (0, $exb0h.ROUTE_NAMES_PROJECT_PAGES)
];
const $a535dee5e72444bb$export$5d4001dfef33123d = ()=>{
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const route = (0, $10fdS.useCurrentRoute)();
    const isFirstActivationDateWithinLast14Days = (0, $cLjmt.useIsFirstActivationDateWithinLastMemo)({
        days: 14
    });
    const isFirstActivationDateAfterOneDay = (0, $hCxgq.useIsFirstActivationDateAfterOneDayMemo)();
    return isSiteAdmin && $a535dee5e72444bb$var$eligibleRoutes.includes(route.name) && isFirstActivationDateWithinLast14Days && isFirstActivationDateAfterOneDay;
};

});
parcelRegister("hCxgq", function(module, exports) {

$parcel$export(module.exports, "useIsFirstActivationDateAfterOneDayMemo", () => $077593bd008899c1$export$f96ca5090cd1f561);

var $eUqFw = parcelRequire("eUqFw");

var $21Sgb = parcelRequire("21Sgb");
const $077593bd008899c1$var$dayInMs = 86400000;
const $077593bd008899c1$export$f96ca5090cd1f561 = ()=>{
    const firstActivationDate = (0, $21Sgb.useFirstActivationDateMs)();
    const isAfterOneDay = (0, $eUqFw.useMemo)(()=>{
        if (!firstActivationDate) return false;
        return (Date.now() - firstActivationDate) / $077593bd008899c1$var$dayInMs >= 1;
    }, [
        firstActivationDate
    ]);
    return isAfterOneDay;
};

});
parcelRegister("21Sgb", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $080756a4d87be123$export$9df3a539e50a284b);

var $gd0Sp = parcelRequire("gd0Sp");
const $080756a4d87be123$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});


parcelRegister("cLjmt", function(module, exports) {

$parcel$export(module.exports, "useIsFirstActivationDateWithinLastMemo", () => $80c660e4df4942f0$export$3d3d42a039703425);

var $eUqFw = parcelRequire("eUqFw");

var $21Sgb = parcelRequire("21Sgb");

var $li0pR = parcelRequire("li0pR");
const $80c660e4df4942f0$export$3d3d42a039703425 = (duration)=>{
    const firstActivationDate = (0, $21Sgb.useFirstActivationDateMs)();
    return (0, $eUqFw.useMemo)(()=>(0, $li0pR.isWithinLast)(duration)(firstActivationDate), [
        duration,
        firstActivationDate
    ]);
};

});
parcelRegister("li0pR", function(module, exports) {

$parcel$export(module.exports, "isWithinLast", () => $f9fbe1fa8b24f371$export$15bc1a874225842d);

var $aRS7n = parcelRequire("aRS7n");

var $9pRhM = parcelRequire("9pRhM");

var $9myoq = parcelRequire("9myoq");
const $f9fbe1fa8b24f371$export$15bc1a874225842d = (duration)=>(date)=>{
        if (!(0, $aRS7n.default)(date)) return false;
        const end = Date.now();
        const start = (0, $9myoq.default)(duration)(end);
        // `isValid` precludes a nullable date.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $9pRhM.default)({
            start: start,
            end: end
        })(date);
    };

});





//# sourceMappingURL=async-jira-des-share-link.4740307f.js.map
